// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3M0P-","content":"styles_content__2QGCd","tableWrap":"styles_tableWrap__3hfG8"};